export default {
  FORGOT_START: "FORGOT_START",
  FORGOT_SUCCESS: "FORGOT_SUCCESS",
  FORGOT_ERROR: "FORGOT_ERROR",
};
